<template>
  <div class="text-xs-center">
    <component
      :is="menu ? 'v-menu' : 'div'"
      v-model="show"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      max-width="480"
      lazy
    >
      <template #activator="{ on }">
        <v-btn v-if="menu" flat icon v-on="on">
          <!-- <v-icon dark>filter_list</v-icon> -->
          <v-badge color="red" overlap>
            <span v-if="filtersCount" slot="badge">{{ filtersCount }}</span>
            <v-icon>tune</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <component :is="menu ? 'v-card' : 'div'">
        <v-layout wrap row pa-3>
          <v-flex xs12 px-2>
            <entity-field
              v-model="filters.entity"
              :disabled="notRole"
              :label="$tc('models.entity')"
              filter-data
              @update:teams="handleTeamsUpdate"
            />
          </v-flex>
          <v-flex xs12 px-2>
            <team-field
              v-model="filters.team"
              :disabled="notRole"
              :label="$tc('models.team')"
              :entity-id="filters.entity"
            />
          </v-flex>
          <v-divider />
          <v-flex v-if="!typeRole" xs12 px-2>
            <v-autocomplete
              v-model="filters.typeRole"
              :items="roleSelectList"
              :disabled="notRole"
              multiple
              item-value="type"
              chips
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.role', 2) })
              "
            >
              <template #selection="data">
                <v-chip color="primary" dark small>
                  {{ data.item.text }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-checkbox
              v-model="filters.subscribed"
              :disabled="notRole"
              :label="$t('titles.users.subscribed')"
              color="primary"
            />
          </v-flex>
          <v-flex v-if="is(['president', 'coordinator'])" xs12 md6 px-2>
            <v-checkbox
              v-model="filters.isClubPaymentDone"
              :disabled="notRole"
              :label="$t('fields.users.isClubPaymentDone')"
              color="primary"
              @change="(val) => (filters.isClubPaymentDone = val || undefined)"
            />
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-checkbox
              v-model="filters.deleted"
              :disabled="notRole"
              :label="$t('titles.users.showDeleted')"
              color="primary"
            />
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-checkbox
              v-model="filters.isAccountDisabled"
              :disabled="notRole"
              :label="$t('fields.users.unregisteredUser')"
              color="primary"
            />
          </v-flex>

          <v-flex xs12 md6 px-2>
            <v-checkbox
              :value="filters.notRole"
              :disabled="createdByMe"
              :label="$t('titles.users.notRole')"
              color="primary"
              @change="onChangeNotRole"
            />
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-checkbox
              :value="filters.createdByMe"
              :disabled="notRole"
              :label="$t('titles.global.showOnlyCreatedByMe')"
              color="primary"
              @change="onChangeCreatedByMe"
            />
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-checkbox
              v-model="filters.onlyRecordRoles"
              :disabled="notRole"
              :label="$t('titles.users.onlyRecordRoles')"
              color="primary"
            />
          </v-flex>
          <template v-if="customFilters">
            <v-flex xs12>
              <h4>{{ $t('fields.global.createdAt') }}</h4>
              <v-layout wrap row>
                <v-flex xs12 md6 px-2>
                  <date-picker
                    v-model="filters.dateStart"
                    :label="$t('fields.tournaments.startAt')"
                  />
                </v-flex>

                <v-flex xs12 md6 px-2>
                  <date-picker
                    v-model="filters.dateEnd"
                    :label="$t('fields.tournaments.endAt')"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <h4>{{ $t('fields.users.lastAccess') }}</h4>
              <v-layout wrap row>
                <v-flex xs12 md6 px-2>
                  <date-picker
                    v-model="filters.dateStartAccess"
                    :label="$t('fields.tournaments.startAt')"
                  />
                </v-flex>

                <v-flex xs12 md6 px-2>
                  <date-picker
                    v-model="filters.dateEndAccess"
                    :label="$t('fields.tournaments.endAt')"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </template>
          <v-layout justify-center>
            <v-flex xs12 md6 class="text-xs-center">
              <v-btn
                small
                :color="customFilters ? 'error' : 'primary'"
                flat
                @click="onChangeAdvancedSearch"
              >
                {{ $t('titles.global.advancedSearch') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>

        <template v-if="menu">
          <v-divider />
          <v-card-actions>
            <v-spacer />

            <v-btn
              color="primary"
              flat
              :loading="$store.state.users.loading"
              @click="search"
            >
              {{ $t('action.buttons.search') }}
            </v-btn>
          </v-card-actions>
        </template>
      </component>
    </component>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DatePicker from '@/components/widgets/Input/DatePicker'
import EntityField from '@/components/widgets/Input/EntityField'
import TeamField from '@/components/widgets/Input/TeamField'
export default {
  name: 'UserFilters',
  components: { TeamField, EntityField, DatePicker },
  props: {
    value: { type: Object, default: () => ({}) },
    menu: { type: Boolean, default: true },
    typeRole: { type: String },
  },
  data: () => ({
    show: false,
    notRole: false,
    createdByMe: false,
    customFilters: false,
  }),
  computed: {
    ...mapGetters({
      roleSelectList: 'roles/selectListFiltered',
    }),
    filters: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    filtersCount() {
      let count = 0
      Object.keys(this.filters).forEach((key) => {
        if (
          key != 'match' &&
          this.filters[key] &&
          (this.filters[key] === true || this.filters[key].length)
        ) {
          count++
        }
      })
      return count
    },
  },
  mounted() {
    this.filters.typeRole = this.typeRole
    this.createdByMe = this.filters.createdByMe
    this.notRole = this.filters.notRole
  },
  methods: {
    handleTeamsUpdate() {
      this.filters.team = ''
    },
    search() {
      this.show = false
      this.$emit('search')
    },
    clearFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined
      })
    },
    onChangeNotRole(val) {
      this.clearFilters()

      if (val) {
        this.filters.notRole = val
      } else {
        this.filters.notRole = undefined
      }
      this.notRole = val
    },
    onChangeCreatedByMe(val) {
      if (val) {
        this.filters.createdByMe = this.$store.state.auth.user._id
      }

      this.createdByMe = val
    },
    onChangeAdvancedSearch() {
      this.customFilters = !this.customFilters
      if (!this.customFilters) {
        this.filters.dateStart = undefined
        this.filters.dateEnd = undefined
        this.filters.dateStartAccess = undefined
        this.filters.dateEndAccess = undefined
      }
    },
  },
}
</script>
